import * as e from "react";
function n() {
  return n = Object.assign ? Object.assign.bind() : function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, n.apply(this, arguments);
}
const t = ["children", "options"];
var r, i;
!function (e) {
  e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}(r || (r = {})), function (e) {
  e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}(i || (i = {}));
const l = ["allowFullScreen", "allowTransparency", "autoComplete", "autoFocus", "autoPlay", "cellPadding", "cellSpacing", "charSet", "className", "classId", "colSpan", "contentEditable", "contextMenu", "crossOrigin", "encType", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "frameBorder", "hrefLang", "inputMode", "keyParams", "keyType", "marginHeight", "marginWidth", "maxLength", "mediaGroup", "minLength", "noValidate", "radioGroup", "readOnly", "rowSpan", "spellCheck", "srcDoc", "srcLang", "srcSet", "tabIndex", "useMap"].reduce((e, n) => (e[n.toLowerCase()] = n, e), {
    for: "htmlFor"
  }),
  o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: " ",
    quot: "“"
  },
  c = ["style", "script"],
  a = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,
  s = /mailto:/i,
  d = /\n{2,}$/,
  u = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/,
  p = /^ *> ?/gm,
  f = /^ {2,}\n/,
  h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/,
  m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/,
  g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,
  y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
  k = /^(?:\n *)*\n/,
  x = /\r\n?/g,
  v = /^\[\^([^\]]+)](:.*)\n/,
  b = /^\[\^([^\]]+)]/,
  $ = /\f/g,
  S = /^\s*?\[(x|\s)\]/,
  w = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,
  C = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,
  E = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,
  A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i,
  O = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi,
  T = /^<!--[\s\S]*?(?:-->)/,
  L = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/,
  z = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,
  M = /^\{.*\}$/,
  I = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
  R = /^<([^ >]+@[^ >]+)>/,
  U = /^<([^ >]+:\/[^ >]+)>/,
  j = /-([a-z])?/gi,
  B = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/,
  N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/,
  H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/,
  D = /^\[([^\]]*)\] ?\[([^\]]*)\]/,
  P = /(\[|\])/g,
  _ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,
  F = /\t/g,
  W = /^ *\| */,
  G = /(^ *\||\| *$)/g,
  Z = / *$/,
  q = /^ *:-+: *$/,
  V = /^ *:-+ *$/,
  X = /^ *-+: *$/,
  Q = /^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/,
  J = /^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/,
  K = /^==((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)==/,
  Y = /^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/,
  ee = /^\\([^0-9A-Za-z\s])/,
  ne = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,
  te = /^\n+/,
  re = /^([ \t]*)/,
  ie = /\\([^\\])/g,
  le = / *\n+$/,
  oe = /(?:^|\n)( *)$/,
  ce = "(?:\\d+\\.)",
  ae = "(?:[*+-])";
function se(e) {
  return "( *)(" + (1 === e ? ce : ae) + ") +";
}
const de = se(1),
  ue = se(2);
function pe(e) {
  return new RegExp("^" + (1 === e ? de : ue));
}
const fe = pe(1),
  he = pe(2);
function me(e) {
  return new RegExp("^" + (1 === e ? de : ue) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? ce : ae) + " )[^\\n]*)*(\\n|$)", "gm");
}
const ge = me(1),
  ye = me(2);
function ke(e) {
  const n = 1 === e ? ce : ae;
  return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const xe = ke(1),
  ve = ke(2);
function be(e, n) {
  const t = 1 === n,
    r = t ? xe : ve,
    i = t ? ge : ye,
    l = t ? fe : he;
  return {
    match(e, n, t) {
      const i = oe.exec(t);
      return i && (n.list || !n.inline && !n.simple) ? r.exec(e = i[1] + e) : null;
    },
    order: 1,
    parse(e, n, r) {
      const o = t ? +e[2] : void 0,
        c = e[0].replace(d, "\n").match(i);
      let a = !1;
      return {
        items: c.map(function (e, t) {
          const i = l.exec(e)[0].length,
            o = new RegExp("^ {1," + i + "}", "gm"),
            s = e.replace(o, "").replace(l, ""),
            d = t === c.length - 1,
            u = -1 !== s.indexOf("\n\n") || d && a;
          a = u;
          const p = r.inline,
            f = r.list;
          let h;
          r.list = !0, u ? (r.inline = !1, h = s.replace(le, "\n\n")) : (r.inline = !0, h = s.replace(le, ""));
          const m = n(h, r);
          return r.inline = p, r.list = f, m;
        }),
        ordered: t,
        start: o
      };
    },
    render: (n, t, r) => e(n.ordered ? "ol" : "ul", {
      key: r.key,
      start: "20" === n.type ? n.start : void 0
    }, n.items.map(function (n, i) {
      return e("li", {
        key: i
      }, t(n, r));
    }))
  };
}
const $e = /^\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/,
  Se = /^!\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/,
  we = [u, m, g, w, E, C, T, B, ge, xe, ye, ve],
  Ce = [...we, /^[^\n]+(?:  \n|\n{2,})/, A, z];
function Ee(e) {
  return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function Ae(e) {
  return X.test(e) ? "right" : q.test(e) ? "center" : V.test(e) ? "left" : null;
}
function Oe(e, n, t) {
  const r = t.inTable;
  t.inTable = !0;
  const i = n(e.trim(), t);
  t.inTable = r;
  let l = [[]];
  return i.forEach(function (e, n) {
    "26" === e.type ? 0 !== n && n !== i.length - 1 && l.push([]) : ("27" !== e.type || null != i[n + 1] && "26" !== i[n + 1].type || (e.text = e.text.replace(Z, "")), l[l.length - 1].push(e));
  }), l;
}
function Te(e, n, t) {
  t.inline = !0;
  const r = Oe(e[1], n, t),
    i = e[2].replace(G, "").split("|").map(Ae),
    l = function (e, n, t) {
      return e.trim().split("\n").map(function (e) {
        return Oe(e, n, t);
      });
    }(e[3], n, t);
  return t.inline = !1, {
    align: i,
    cells: l,
    header: r,
    type: "25"
  };
}
function Le(e, n) {
  return null == e.align[n] ? {} : {
    textAlign: e.align[n]
  };
}
function ze(e) {
  return function (n, t) {
    return t.inline ? e.exec(n) : null;
  };
}
function Me(e) {
  return function (n, t) {
    return t.inline || t.simple ? e.exec(n) : null;
  };
}
function Ie(e) {
  return function (n, t) {
    return t.inline || t.simple ? null : e.exec(n);
  };
}
function Re(e) {
  return function (n) {
    return e.exec(n);
  };
}
function Ue(e, n, t) {
  if (n.inline || n.simple) return null;
  if (t && !t.endsWith("\n")) return null;
  let r = "";
  e.split("\n").every(e => !we.some(n => n.test(e)) && (r += e + "\n", e.trim()));
  const i = r.trimEnd();
  return "" == i ? null : [r, i];
}
function je(e) {
  try {
    if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
  } catch (e) {
    return null;
  }
  return e;
}
function Be(e) {
  return e.replace(ie, "$1");
}
function Ne(e, n, t) {
  const r = t.inline || !1,
    i = t.simple || !1;
  t.inline = !0, t.simple = !0;
  const l = e(n, t);
  return t.inline = r, t.simple = i, l;
}
function He(e, n, t) {
  const r = t.inline || !1,
    i = t.simple || !1;
  t.inline = !1, t.simple = !0;
  const l = e(n, t);
  return t.inline = r, t.simple = i, l;
}
function De(e, n, t) {
  return t.inline = !1, e(n, t);
}
const Pe = (e, n, t) => ({
  children: Ne(n, e[1], t)
});
function _e() {
  return {};
}
function Fe() {
  return null;
}
function We() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }
  return e.filter(Boolean).join(" ");
}
function Ge(e, n, t) {
  let r = e;
  const i = n.split(".");
  for (; i.length && (r = r[i[0]], void 0 !== r);) i.shift();
  return r || t;
}
function Ze(t) {
  let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  r.overrides = r.overrides || {}, r.slugify = r.slugify || Ee, r.namedCodesToUnicode = r.namedCodesToUnicode ? n({}, o, r.namedCodesToUnicode) : o;
  const i = r.createElement || e.createElement;
  function d(e, t) {
    const o = Ge(r.overrides, `${e}.props`, {});
    for (var _len2 = arguments.length, l = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      l[_key2 - 2] = arguments[_key2];
    }
    return i(function (e, n) {
      const t = Ge(n, e);
      return t ? "function" == typeof t || "object" == typeof t && "render" in t ? t : Ge(n, `${e}.component`, e) : e;
    }(e, r.overrides), n({}, t, o, {
      className: We(null == t ? void 0 : t.className, o.className) || void 0
    }), ...l);
  }
  function G(n) {
    let t = !1;
    r.forceInline ? t = !0 : r.forceBlock || (t = !1 === _.test(n));
    const i = le(ie(t ? n : `${n.trimEnd().replace(te, "")}\n\n`, {
      inline: t
    }));
    for (; "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();) i.pop();
    if (null === r.wrapper) return i;
    const l = r.wrapper || (t ? "span" : "div");
    let o;
    if (i.length > 1 || r.forceWrapper) o = i;else {
      if (1 === i.length) return o = i[0], "string" == typeof o ? d("span", {
        key: "outer"
      }, o) : o;
      o = null;
    }
    return e.createElement(l, {
      key: "outer"
    }, o);
  }
  function Z(n) {
    const t = n.match(a);
    return t ? t.reduce(function (n, t, r) {
      const i = t.indexOf("=");
      if (-1 !== i) {
        const o = function (e) {
            return -1 !== e.indexOf("-") && null === e.match(L) && (e = e.replace(j, function (e, n) {
              return n.toUpperCase();
            })), e;
          }(t.slice(0, i)).trim(),
          c = function (e) {
            const n = e[0];
            return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
          }(t.slice(i + 1).trim()),
          a = l[o] || o,
          s = n[a] = function (e, n) {
            return "style" === e ? n.split(/;\s?/).reduce(function (e, n) {
              const t = n.slice(0, n.indexOf(":"));
              return e[t.replace(/(-[a-z])/g, e => e[1].toUpperCase())] = n.slice(t.length + 1).trim(), e;
            }, {}) : "href" === e || "src" === e ? je(n) : (n.match(M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
          }(o, c);
        "string" == typeof s && (A.test(s) || z.test(s)) && (n[a] = e.cloneElement(G(s.trim()), {
          key: r
        }));
      } else "style" !== t && (n[l[t] || t] = !0);
      return n;
    }, {}) : null;
  }
  const q = [],
    V = {},
    X = {
      0: {
        match: Ie(u),
        order: 1,
        parse: (e, n, t) => ({
          children: n(e[0].replace(p, ""), t)
        }),
        render: (e, n, t) => d("blockquote", {
          key: t.key
        }, n(e.children, t))
      },
      1: {
        match: Re(f),
        order: 1,
        parse: _e,
        render: (e, n, t) => d("br", {
          key: t.key
        })
      },
      2: {
        match: Ie(h),
        order: 1,
        parse: _e,
        render: (e, n, t) => d("hr", {
          key: t.key
        })
      },
      3: {
        match: Ie(g),
        order: 0,
        parse: e => ({
          lang: void 0,
          text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
        }),
        render: (e, t, r) => d("pre", {
          key: r.key
        }, d("code", n({}, e.attrs, {
          className: e.lang ? `lang-${e.lang}` : ""
        }), e.text))
      },
      4: {
        match: Ie(m),
        order: 0,
        parse: e => ({
          attrs: Z(e[3] || ""),
          lang: e[2] || void 0,
          text: e[4],
          type: "3"
        })
      },
      5: {
        match: Me(y),
        order: 3,
        parse: e => ({
          text: e[2]
        }),
        render: (e, n, t) => d("code", {
          key: t.key
        }, e.text)
      },
      6: {
        match: Ie(v),
        order: 0,
        parse: e => (q.push({
          footnote: e[2],
          identifier: e[1]
        }), {}),
        render: Fe
      },
      7: {
        match: ze(b),
        order: 1,
        parse: e => ({
          target: `#${r.slugify(e[1])}`,
          text: e[1]
        }),
        render: (e, n, t) => d("a", {
          key: t.key,
          href: je(e.target)
        }, d("sup", {
          key: t.key
        }, e.text))
      },
      8: {
        match: ze(S),
        order: 1,
        parse: e => ({
          completed: "x" === e[1].toLowerCase()
        }),
        render: (e, n, t) => d("input", {
          checked: e.completed,
          key: t.key,
          readOnly: !0,
          type: "checkbox"
        })
      },
      9: {
        match: Ie(r.enforceAtxHeadings ? C : w),
        order: 1,
        parse: (e, n, t) => ({
          children: Ne(n, e[2], t),
          id: r.slugify(e[2]),
          level: e[1].length
        }),
        render: (e, n, t) => d(`h${e.level}`, {
          id: e.id,
          key: t.key
        }, n(e.children, t))
      },
      10: {
        match: Ie(E),
        order: 0,
        parse: (e, n, t) => ({
          children: Ne(n, e[1], t),
          level: "=" === e[2] ? 1 : 2,
          type: "9"
        })
      },
      11: {
        match: Re(A),
        order: 1,
        parse(e, n, t) {
          const [, r] = e[3].match(re),
            i = new RegExp(`^${r}`, "gm"),
            l = e[3].replace(i, ""),
            o = (a = l, Ce.some(e => e.test(a)) ? De : Ne);
          var a;
          const s = e[1].toLowerCase(),
            d = -1 !== c.indexOf(s),
            u = {
              attrs: Z(e[2]),
              noInnerParse: d,
              tag: d ? s : e[1]
            };
          return t.inAnchor = t.inAnchor || "a" === s, d ? u.text = e[3] : u.children = o(n, l, t), t.inAnchor = !1, u;
        },
        render: (e, t, r) => d(e.tag, n({
          key: r.key
        }, e.attrs), e.text || t(e.children, r))
      },
      13: {
        match: Re(z),
        order: 1,
        parse: e => ({
          attrs: Z(e[2] || ""),
          tag: e[1]
        }),
        render: (e, t, r) => d(e.tag, n({}, e.attrs, {
          key: r.key
        }))
      },
      12: {
        match: Re(T),
        order: 1,
        parse: () => ({}),
        render: Fe
      },
      14: {
        match: Me(Se),
        order: 1,
        parse: e => ({
          alt: e[1],
          target: Be(e[2]),
          title: e[3]
        }),
        render: (e, n, t) => d("img", {
          key: t.key,
          alt: e.alt || void 0,
          title: e.title || void 0,
          src: je(e.target)
        })
      },
      15: {
        match: ze($e),
        order: 3,
        parse: (e, n, t) => ({
          children: He(n, e[1], t),
          target: Be(e[2]),
          title: e[3]
        }),
        render: (e, n, t) => d("a", {
          key: t.key,
          href: je(e.target),
          title: e.title
        }, n(e.children, t))
      },
      16: {
        match: ze(U),
        order: 0,
        parse: e => ({
          children: [{
            text: e[1],
            type: "27"
          }],
          target: e[1],
          type: "15"
        })
      },
      17: {
        match: (e, n) => n.inAnchor ? null : ze(I)(e, n),
        order: 0,
        parse: e => ({
          children: [{
            text: e[1],
            type: "27"
          }],
          target: e[1],
          title: void 0,
          type: "15"
        })
      },
      18: {
        match: ze(R),
        order: 0,
        parse(e) {
          let n = e[1],
            t = e[1];
          return s.test(t) || (t = "mailto:" + t), {
            children: [{
              text: n.replace("mailto:", ""),
              type: "27"
            }],
            target: t,
            type: "15"
          };
        }
      },
      20: be(d, 1),
      33: be(d, 2),
      19: {
        match: Ie(k),
        order: 3,
        parse: _e,
        render: () => "\n"
      },
      21: {
        match: Ue,
        order: 3,
        parse: Pe,
        render: (e, n, t) => d("p", {
          key: t.key
        }, n(e.children, t))
      },
      22: {
        match: ze(N),
        order: 0,
        parse: e => (V[e[1]] = {
          target: e[2],
          title: e[4]
        }, {}),
        render: Fe
      },
      23: {
        match: Me(H),
        order: 0,
        parse: e => ({
          alt: e[1] || void 0,
          ref: e[2]
        }),
        render: (e, n, t) => d("img", {
          key: t.key,
          alt: e.alt,
          src: je(V[e.ref].target),
          title: V[e.ref].title
        })
      },
      24: {
        match: ze(D),
        order: 0,
        parse: (e, n, t) => ({
          children: n(e[1], t),
          fallbackChildren: n(e[0].replace(P, "\\$1"), t),
          ref: e[2]
        }),
        render: (e, n, t) => V[e.ref] ? d("a", {
          key: t.key,
          href: je(V[e.ref].target),
          title: V[e.ref].title
        }, n(e.children, t)) : d("span", {
          key: t.key
        }, n(e.fallbackChildren, t))
      },
      25: {
        match: Ie(B),
        order: 1,
        parse: Te,
        render: (e, n, t) => d("table", {
          key: t.key
        }, d("thead", null, d("tr", null, e.header.map(function (r, i) {
          return d("th", {
            key: i,
            style: Le(e, i)
          }, n(r, t));
        }))), d("tbody", null, e.cells.map(function (r, i) {
          return d("tr", {
            key: i
          }, r.map(function (r, i) {
            return d("td", {
              key: i,
              style: Le(e, i)
            }, n(r, t));
          }));
        })))
      },
      26: {
        match: function (e, n) {
          return n.inTable ? (n.inline = !0, W.exec(e)) : null;
        },
        order: 1,
        parse: function () {
          return {
            type: "26"
          };
        },
        render: () => " | "
      },
      27: {
        match: Re(ne),
        order: 4,
        parse: e => ({
          text: e[0].replace(O, (e, n) => r.namedCodesToUnicode[n] ? r.namedCodesToUnicode[n] : e)
        }),
        render: e => e.text
      },
      28: {
        match: Me(Q),
        order: 2,
        parse: (e, n, t) => ({
          children: n(e[2], t)
        }),
        render: (e, n, t) => d("strong", {
          key: t.key
        }, n(e.children, t))
      },
      29: {
        match: Me(J),
        order: 3,
        parse: (e, n, t) => ({
          children: n(e[2], t)
        }),
        render: (e, n, t) => d("em", {
          key: t.key
        }, n(e.children, t))
      },
      30: {
        match: Me(ee),
        order: 1,
        parse: e => ({
          text: e[1],
          type: "27"
        })
      },
      31: {
        match: Me(K),
        order: 3,
        parse: Pe,
        render: (e, n, t) => d("mark", {
          key: t.key
        }, n(e.children, t))
      },
      32: {
        match: Me(Y),
        order: 3,
        parse: Pe,
        render: (e, n, t) => d("del", {
          key: t.key
        }, n(e.children, t))
      }
    };
  !0 === r.disableParsingRawHTML && (delete X[11], delete X[13]);
  const ie = function (e) {
      let n = Object.keys(e);
      function t(r, i) {
        let l = [],
          o = "";
        for (; r;) {
          let c = 0;
          for (; c < n.length;) {
            const a = n[c],
              s = e[a],
              d = s.match(r, i, o);
            if (d) {
              const e = d[0];
              r = r.substring(e.length);
              const n = s.parse(d, t, i);
              null == n.type && (n.type = a), l.push(n), o = e;
              break;
            }
            c++;
          }
        }
        return l;
      }
      return n.sort(function (n, t) {
        let r = e[n].order,
          i = e[t].order;
        return r !== i ? r - i : 1;
      }), function (e, n) {
        return t(function (e) {
          return e.replace(x, "\n").replace($, "").replace(F, "    ");
        }(e), n);
      };
    }(X),
    le = (oe = function (e, n) {
      return function (t, r, i) {
        const l = e[t.type].render;
        return n ? n(() => l(t, r, i), t, r, i) : l(t, r, i);
      };
    }(X, r.renderRule), function e(n) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (Array.isArray(n)) {
        const r = t.key,
          i = [];
        let l = !1;
        for (let r = 0; r < n.length; r++) {
          t.key = r;
          const o = e(n[r], t),
            c = "string" == typeof o;
          c && l ? i[i.length - 1] += o : null !== o && i.push(o), l = c;
        }
        return t.key = r, i;
      }
      return oe(n, e, t);
    });
  var oe;
  const ce = G(t);
  return q.length ? d("div", null, ce, d("footer", {
    key: "footer"
  }, q.map(function (e) {
    return d("div", {
      id: r.slugify(e.identifier),
      key: e.identifier
    }, e.identifier, le(ie(e.footnote, {
      inline: !0
    })));
  }))) : ce;
}
export default n => {
  let {
      children: r,
      options: i
    } = n,
    l = function (e, n) {
      if (null == e) return {};
      var t,
        r,
        i = {},
        l = Object.keys(e);
      for (r = 0; r < l.length; r++) n.indexOf(t = l[r]) >= 0 || (i[t] = e[t]);
      return i;
    }(n, t);
  return e.cloneElement(Ze(r, i), l);
};
export { r as RuleType, Ze as compiler };